import React from 'react';

// Subtle abstract background for dark sections: low-contrast tech grid + red accent glow.
// variant: 'mesh' (dot grid) | 'lines' (line grid) | 'flow' (gradient sweep for process/transfer)
// glow: 'tr' | 'bl' | 'center'
const DarkPattern = ({ variant = 'mesh', glow = 'tr' }) => {
  const patternClass =
    variant === 'lines' ? 'tech-line-grid' : variant === 'flow' ? 'tech-flow' : 'tech-dot-grid';
  const glowPos =
    glow === 'bl'
      ? '-bottom-40 -left-40'
      : glow === 'center'
      ? 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
      : '-top-40 -right-40';

  return (
    <>
      <div className={`pointer-events-none absolute inset-0 ${patternClass}`} aria-hidden="true" />
      <div
        className={`pointer-events-none absolute w-[32rem] h-[32rem] rounded-full bg-red-600/20 blur-[130px] ${glowPos}`}
        aria-hidden="true"
      />
    </>
  );
};

export default DarkPattern;
